/** Demo Mode only - Finance > Profit & Loss tab. Wraps the shared, scope-aware
 * ProfitAndLossTable, driven entirely by the shared scope selector/filter bar. */

import { useEffect } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Section } from '../../../components/ui/Section';
import useCurrencyCodeConfiguration from '../../../hooks/configurations/useCurrencyCodeConfiguration';
import { useFinanceFilters } from '../FinanceFiltersContext';
import ProfitAndLossTable from '../components/ProfitAndLossTable';

const ProfitAndLossTab = () => {
  const { t } = useTranslation('common');
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();
  const { scopedContracts, view, setView, scopeLabel } = useFinanceFilters();

  useEffect(() => {
    getCurrencyCodeConfiguration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Section style={{ p: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="textMD"
          fontWeight={600}>
          {`${t('profitAndLossTitle', 'Profit & Loss')} - ${scopeLabel}`}
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={view}
          onChange={(_e, next) => next && setView(next)}
        >
          <ToggleButton value="ytd">{t('financeViewYtd', 'Year to date')}</ToggleButton>
          <ToggleButton value="fullYear">{t('financeViewFullYear', 'Full year')}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {scopedContracts.length === 0 ? (
        <Typography variant="textSM"
          color="text.secondary">{t('financeNoContractsInScope', 'No contracts match the current scope/filters.')}</Typography>
      ) : (
        <ProfitAndLossTable contracts={scopedContracts}
          view={view}
          currencyCode={currencyCode} />
      )}
    </Section>
  );
};

export default ProfitAndLossTab;
